import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MatCheckboxChange, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { BottomSheetHelperService } from '../../services/bottomSheetHelper.service';
import { CoreCOMService } from '../../services/com.service';
import { ItemTagHelperService } from '../../services/itemTagHelper.service';
import { CoreLogService } from '../../services/log.service';
import { UserHelperService } from '../../services/userHelper.service';
import { LocalKeys, StorageHive } from '../../services/valueStorage.service';
import { ItemTagStatusType, ItemTagType, SortDirection } from '../../shared/contentTypes';
import { ItemGroupViewModel } from '../../shared/models';
import { SortOption } from '../../shared/models/sort.model';
import { PagingHelper } from '../../shared/pagingHelper';
import { LoginDialogComponent } from '../logindialog/logindialog.component';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'ya-menunavdialog',
  templateUrl: './menuNavDialog.component.html',
  styleUrls: ['./menuNavDialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuNavDialogComponent implements OnInit {

  public showGradient: boolean = true;
  public items: { label: string, id: number }[];
  public labels?: string[];
  public activeLabelIndex?: number;



  constructor(public bottomSheetRef: MatBottomSheetRef<MenuNavDialogComponent>
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , public _userHelperService: UserHelperService
    , private _activatedRoute: ActivatedRoute
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    this._router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  PushChanges() {
    if (!this._changeDetectorRef['destroyed']) {
      try {
        this._changeDetectorRef.detectChanges();
      } catch (e) {
        this._coreLogService.error("menuNavComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
      }
    }
  }

  ngOnInit() {
    const me = this;

    if (me.data && me.data.itemGroups) {
      const itemGroupsArray = me.data.itemGroups;
      if (Array.isArray(itemGroupsArray)) {
        me.items = itemGroupsArray.map(item => ({
          label: item.label,
          id: item.id
        }));
      }
    }

    // Zugriff auf die labelData
    if (me.data && me.data.labelData) {
      const labelDataArray = me.data.labelData;
      if (Array.isArray(labelDataArray)) {
        me.activeLabelIndex = labelDataArray.findIndex(item => item.isActive);
      }
    }
  }

  public extractItems(data: any[], labelKey: string): { label: string, id: number }[] {
    const items = data.map(item => ({ label: item[labelKey], id: item.id }));
    console.log('Items:', items);
    return items;
  }

  navigateToItem(item: { label: string, id: number }) {
    this._router.navigate(['/menu/', item.id]).then(() => {
      this._router.navigated = false;
    });
    this.bottomSheetRef.dismiss();
  }

  public closeDialog() {
    const me = this;
    me.bottomSheetRef.dismiss();
  }

}
